<template>
    <div id="cookie-consent" v-show="visible">
        <div class="grid-container">
            <div class="grid-x grid-padding-x grid-padding-y">
                <div class="cell auto">
                    <p>
                        We use cookies to help provide you with the best possible online experience.<br />
                        By using this site, you agree that we may store and access cookies on your device. You can find out more and set your own preferences <a href="/cookies">here</a>.
                    </p>
                </div>
                <div class="cell shrink">
                    <span class="small success button mrb0" @click="set"><i class="fas fa-check fa-fw"></i> GOT IT</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Cookie from './Cookie.vue';
    export default {
        extends: Cookie,
        computed: {
            visible() {
                return ! this.isCookie;
            }
        }
    };
</script>